module.exports = __webpack_public_path__ + "img/image_loading.601c026c.gif";